import React from "react";
import "../styles/Navbar.css";

export default function Footer() {
  return (
    <footer className="footer">
        <a target="_blank" href="https://github.com/hope428"><i class="fa-brands fa-github"></i></a>
        <a target="_blank" href="https://www.linkedin.com/in/leon-forsythe-54357b239/"><i class="fa-brands fa-linkedin"></i></a>
    </footer>
  );
}
